// iPhone device specifications
// All measurements in logical points (actual screen dimensions)
export const DEVICE_SPECS = {
  'iphone-15': {
    name: 'iPhone 15',
    width: 393,
    height: 852,
    scale: 0.4,
    notch: true,
    dynamicIsland: false,
    bezelWidth: 8, // Realistic bezel width
    notchWidth: 126,
    notchHeight: 30,
    homeIndicatorWidth: 134,
    homeIndicatorHeight: 5,
    cornerRadius: 47, // iPhone corner radius
    bezelColor: 'aluminum', // aluminum for regular, titanium for pro
  },
  'iphone-15-pro': {
    name: 'iPhone 15 Pro',
    width: 393,
    height: 852,
    scale: 0.4,
    notch: true,
    dynamicIsland: false,
    bezelWidth: 8,
    notchWidth: 126,
    notchHeight: 30,
    homeIndicatorWidth: 134,
    homeIndicatorHeight: 5,
    cornerRadius: 47,
    bezelColor: 'titanium',
  },
  'iphone-15-plus': {
    name: 'iPhone 15 Plus',
    width: 430,
    height: 932,
    scale: 0.38,
    notch: true,
    dynamicIsland: false,
    bezelWidth: 8,
    notchWidth: 126,
    notchHeight: 30,
    homeIndicatorWidth: 134,
    homeIndicatorHeight: 5,
    cornerRadius: 47,
    bezelColor: 'aluminum',
  },
  'iphone-15-pro-max': {
    name: 'iPhone 15 Pro Max',
    width: 430,
    height: 932,
    scale: 0.38,
    notch: true,
    dynamicIsland: false,
    bezelWidth: 8,
    notchWidth: 126,
    notchHeight: 30,
    homeIndicatorWidth: 134,
    homeIndicatorHeight: 5,
    cornerRadius: 47,
    bezelColor: 'titanium',
  },
  'iphone-16': {
    name: 'iPhone 16',
    width: 393,
    height: 852,
    scale: 0.4,
    notch: true,
    dynamicIsland: false,
    bezelWidth: 8,
    notchWidth: 126,
    notchHeight: 30,
    homeIndicatorWidth: 134,
    homeIndicatorHeight: 5,
    cornerRadius: 47,
    bezelColor: 'aluminum',
  },
  'iphone-16-pro': {
    name: 'iPhone 16 Pro',
    width: 402,
    height: 873,
    scale: 0.39,
    notch: false,
    dynamicIsland: true,
    bezelWidth: 8,
    dynamicIslandWidth: 126,
    dynamicIslandHeight: 37,
    homeIndicatorWidth: 134,
    homeIndicatorHeight: 5,
    cornerRadius: 47,
    bezelColor: 'titanium',
  },
  'iphone-16-plus': {
    name: 'iPhone 16 Plus',
    width: 430,
    height: 932,
    scale: 0.38,
    notch: true,
    dynamicIsland: false,
    bezelWidth: 8,
    notchWidth: 126,
    notchHeight: 30,
    homeIndicatorWidth: 134,
    homeIndicatorHeight: 5,
    cornerRadius: 47,
    bezelColor: 'aluminum',
  },
  'iphone-16-pro-max': {
    name: 'iPhone 16 Pro Max',
    width: 456,
    height: 947,
    scale: 0.36,
    notch: false,
    dynamicIsland: true,
    bezelWidth: 8,
    dynamicIslandWidth: 126,
    dynamicIslandHeight: 37,
    homeIndicatorWidth: 134,
    homeIndicatorHeight: 5,
    cornerRadius: 47,
    bezelColor: 'titanium',
  },
  'iphone-17': {
    name: 'iPhone 17',
    width: 393,
    height: 852,
    scale: 0.4,
    notch: true,
    dynamicIsland: false,
    bezelWidth: 8,
    notchWidth: 126,
    notchHeight: 30,
    homeIndicatorWidth: 134,
    homeIndicatorHeight: 5,
    cornerRadius: 47,
    bezelColor: 'aluminum',
  },
  'iphone-17-pro': {
    name: 'iPhone 17 Pro',
    width: 402,
    height: 873,
    scale: 0.39,
    notch: false,
    dynamicIsland: true,
    bezelWidth: 8,
    dynamicIslandWidth: 126,
    dynamicIslandHeight: 37,
    homeIndicatorWidth: 134,
    homeIndicatorHeight: 5,
    cornerRadius: 47,
    bezelColor: 'titanium',
  },
  'iphone-17-plus': {
    name: 'iPhone 17 Plus',
    width: 430,
    height: 932,
    scale: 0.38,
    notch: true,
    dynamicIsland: false,
    bezelWidth: 8,
    notchWidth: 126,
    notchHeight: 30,
    homeIndicatorWidth: 134,
    homeIndicatorHeight: 5,
    cornerRadius: 47,
    bezelColor: 'aluminum',
  },
  'iphone-17-pro-max': {
    name: 'iPhone 17 Pro Max',
    width: 456,
    height: 947,
    scale: 0.36,
    notch: false,
    dynamicIsland: true,
    bezelWidth: 8,
    dynamicIslandWidth: 126,
    dynamicIslandHeight: 37,
    homeIndicatorWidth: 134,
    homeIndicatorHeight: 5,
    cornerRadius: 47,
    bezelColor: 'titanium',
  },
};

export const DEFAULT_DEVICE = 'iphone-15-pro';
